import React from 'react';
import PropTypes from 'prop-types';
import { colorGray } from 'styles/layout/colors';

const IconPlushCushions = ({
  color = colorGray,
  width = '48',
  height = '48',
  className = '',
}) => {
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M18.5122 19.266C15.6713 19.266 13.2476 21.2302 12.6138 23.9369H12.5023C10.02 23.9369 8 25.9569 8 28.4392V28.5414C8 31.0237 10.0201 33.0437 12.5023 33.0437H35.4802C37.9624 33.0437 39.9824 31.0236 39.9824 28.5414V28.4392C39.9824 26.0127 38.054 24.0283 35.6502 23.9396C35.7099 23.5279 35.7391 23.1108 35.7391 22.6938C35.7391 17.8991 31.8383 14 27.0453 14C23.5379 14 20.3994 16.1011 19.0448 19.2901C18.8668 19.2741 18.6889 19.2662 18.5122 19.2662L18.5122 19.266ZM27.0441 15.5511C30.982 15.5511 34.1855 18.7546 34.1855 22.6925C34.1855 23.3074 34.1058 23.921 33.9504 24.5147C33.8893 24.7471 33.9398 24.9955 34.0859 25.1854C34.2333 25.3766 34.4591 25.4882 34.7008 25.4882H35.4804C37.1074 25.4882 38.4302 26.811 38.4302 28.438V28.5402C38.4302 30.1658 37.1074 31.49 35.4804 31.49L12.5025 31.4913C10.8756 31.4913 9.55276 30.1672 9.55276 28.5416V28.4393C9.55276 26.8123 10.8756 25.4895 12.5025 25.4895H13.2662C13.6607 25.4895 13.9914 25.1947 14.0378 24.8029C14.3008 22.5318 16.2253 20.8184 18.5136 20.8184C18.7819 20.8184 19.0528 20.8463 19.3211 20.8955C20.6506 21.5091 21.2442 22.0469 21.6427 22.9952C21.7675 23.2927 22.0557 23.4707 22.3585 23.4707C22.4595 23.4707 22.5604 23.4521 22.6587 23.4096C23.0531 23.2436 23.2391 22.788 23.0731 22.3936C22.5272 21.096 21.6613 20.3576 20.5364 19.7652C21.6786 17.2192 24.2138 15.5509 27.0443 15.5509L27.0441 15.5511Z"
      fill={color}
    />
  </svg>;
};

IconPlushCushions.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
};

export default IconPlushCushions;
